import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const Home = () => {
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const correctPassword = "EmbedDemo!!2025"; // You should change this to your desired password

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setIsAuthenticated(true);
    } else {
      alert("Incorrect password!");
    }
  };

  return (
    <div className="home-container">
      <h1>Welcome to Insurgate</h1>
      <p>This is the home page of our application.</p>

      {!isAuthenticated ? (
        <form onSubmit={handlePasswordSubmit} className="password-form">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            className="password-input"
          />
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      ) : (
        <div className="links-container">
          <Link to="/building" className="nav-link">
            Axa Building
          </Link>
          <Link to="/mng-bike" className="nav-link">
            Mng Bike
          </Link>
          <Link to="/april" className="nav-link">
            April
          </Link>
          <Link to="/soco" className="nav-link">
            Soco
          </Link>
          <Link to="/stellantis" className="nav-link">
            Stellantis
          </Link>
          <Link to="/custom" className="nav-link">
            Custom
          </Link>
        </div>
      )}
    </div>
  );
};

export default Home;
